

































import Vue from 'vue'
import { Component } from 'vue-property-decorator'
import PulseLoader from 'vue-spinner/src/PulseLoader.vue'
import { OrderHistoryResp_Order, Timestamp } from '@/apiv3/index'
import formatter from '@/helpers'
import auth from '@/auth'

@Component({ components: { PulseLoader } })
export default class History extends Vue {
  public loaded = false
  public orders: OrderHistoryResp_Order[] | undefined = undefined

  mounted (): void {
    auth.userClient().OrderHistory({}).then((resp) => {
      this.orders = resp.orders
    }).finally(() => {
      this.loaded = true
    })
  }

  formatDateOnly (val: Timestamp | undefined): string {
    return formatter.formatDateOnlyTs(val)
  }
}
